export const SITE_AUTHENTICATION_PATHS = {
  START: "/site-authentication/start/",
  SUCCESS: "/site-authentication/success",
  FAILED: "/site-authentication/failed",
  AUTHENTICATION_CALLBACK: "/site-authentication/authentication-callback",
};

export const SITE_AUTHENTICATION_ROUTES = [
  SITE_AUTHENTICATION_PATHS.START,
  SITE_AUTHENTICATION_PATHS.SUCCESS,
  SITE_AUTHENTICATION_PATHS.FAILED,
  SITE_AUTHENTICATION_PATHS.AUTHENTICATION_CALLBACK,
];
